import { Box } from '@mui/material';
import ProfileDrawer from '@/appWrapper/ProfileDrawer';
import SiteFooter from '@/appWrapper/SiteFooter';
import { useUrlChecker } from '@/hooks/useUrlChecker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import SiteHeader from '@/appWrapper/SiteHeader/V1';
import SiteFooterPublic from '@/appWrapper/SiteFooterPublic';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { routes } from '@/constants/Constants';
import { ToastProvider } from '@/components/Toast';
import { CoreWrapper } from '@/components/wrapper/CoreWrapper';
import { SideMenuV1, useMenu } from '@/appWrapper/SideMenu';
import { LayoutProvider } from '@/appWrapper/LayoutContext';
import { RenterInviteDrawer } from '@/features/RenterInvite';
import { useSplitFeatureFlag } from '@/hooks/useSplitFeatureFlag';
import { SplitFeatureFlag } from '@/utils/split/splitConfig';

interface Props {
  children: JSX.Element[] | JSX.Element;
}

const InviteDrawerGate = () => {
  const { isPublic } = useUrlChecker();
  const { isFeatureFlagEnabled } = useSplitFeatureFlag(
    SplitFeatureFlag.MONARCH_460_NEW_RENTER_INVITE_IN_DRAWER,
  );
  if (isPublic || !isFeatureFlagEnabled) return null;
  return <RenterInviteDrawer />;
};

const PageWrapper = ({ children }: Props) => {
  const { menuOpen } = useMenu();
  const { isPublic } = useUrlChecker();
  const preRegister = isPublic || window.location.pathname === routes.unitsOwnedEnroll;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <CoreWrapper>
        <ToastProvider>
          <LayoutProvider>
            <SiteHeader />
            {/* Viewheight minus header.*/}
            <div id="page-container" style={{ minHeight: 'calc(100vh - 148px)' }}>
              {preRegister ? null : <SideMenuV1 />}
              <Box
                sx={{
                  px: { xs: 2, md: isPublic ? 0 : 2 },
                  marginLeft: { md: isPublic ? '0px' : menuOpen ? '303px' : '80px' },
                  transition: 'margin 0.3s linear',
                }}
              >
                {/* Viewheight minus header and footer is page content */}
                <Box
                  sx={{
                    minHeight: preRegister
                      ? 'calc(100vh - 148px - 445px)'
                      : 'calc(100vh - 148px - 130px)',
                    width: '100%',
                    margin: { xl: '0 auto' },
                  }}
                >
                  {children}
                </Box>
                {isPublic ? null : <SiteFooter />}
              </Box>
              {isPublic ? <SiteFooterPublic /> : null}
              <ProfileDrawer />
            </div>
            <InviteDrawerGate />
          </LayoutProvider>
        </ToastProvider>
      </CoreWrapper>
    </LocalizationProvider>
  );
};

export default PageWrapper;
